import { v4 as uuidv4 } from "uuid";
import userImagePlaceholder1 from "@circle-react-shared/BuilderUI/Assets/user_5_image_placeholder.png";
import userImagePlaceholder2 from "@circle-react-shared/BuilderUI/Assets/user_6_image_placeholder.png";
import userImagePlaceholder3 from "@circle-react-shared/BuilderUI/Assets/user_7_image_placeholder.png";
import userImagePlaceholder4 from "@circle-react-shared/BuilderUI/Assets/user_8_image_placeholder.png";
import userImagePlaceholder5 from "@circle-react-shared/BuilderUI/Assets/user_9_image_placeholder.png";
import userImagePlaceholder6 from "@circle-react-shared/BuilderUI/Assets/user_10_image_placeholder.png";
import { TABLET_WIDTH } from "@circle-react-shared/BuilderUI/Canvas/constants";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createTestimonial2Block } from "@circle-react-shared/BuilderUI/DefaultBlocks/Testimonials/Testimonial2/Testimonial2DefaultData";
import { primaryBlockDefaultStyles } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/stylesHelpers";
import {
  createH2Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@circle-react-shared/BuilderUI/utils/boxModelStyleHelpers";
import { getBackgroundColorOptions } from "@circle-react-shared/BuilderUI/utils/buttonStyleHelpers";
import { getMaxWidthOptions } from "@circle-react-shared/BuilderUI/utils/sizeStyleHelpers";
import { getTextAlignOptions } from "@circle-react-shared/BuilderUI/utils/textStyleHelpers";

const cards = [
  {
    userCard: {
      imageSignedId: "",
      placeholder: userImagePlaceholder1,
      header: "Michael Trevez",
      description: "Strategy Director",
    },
    content:
      '"Elevate gave me the structure I didn\'t know I needed. I went from scattered ideas to a complete course in under eight weeks—and launched it. The support and clarity were next level."',
  },
  {
    userCard: {
      imageSignedId: "",
      placeholder: userImagePlaceholder2,
      header: "Jennifer Lorel",
      description: "Curriculum Consultant",
    },
    content:
      "\"What stood out was how practical everything felt. I didn't just learn—I built. Every template, coaching session, and lab moved me forward. It finally feels like I'm building a real education business.\"",
  },
  {
    userCard: {
      imageSignedId: "",
      placeholder: userImagePlaceholder3,
      header: "Sophia Racheal",
      description: "Product Strategist",
    },
    content:
      '"From day one, Elevate helped me see my knowledge as something I could teach at scale. It\'s thoughtful, focused, and results-driven—ideal for anyone serious about doing this right."',
  },
  {
    userCard: {
      imageSignedId: "",
      placeholder: userImagePlaceholder4,
      header: "James Walter",
      description: "Coach & Educator",
    },
    content:
      "\"I used to feel overwhelmed by everything—tech, curriculum, launch plans. Elevate helped me break it all down and rebuild with systems that made sense. It's the first time I've felt in control.\"",
  },
  {
    userCard: {
      imageSignedId: "",
      placeholder: userImagePlaceholder5,
      header: "David Konstas",
      description: "Wellness Educator",
    },
    content:
      '"Before Elevate, I had ideas. Now I have a course, a launch plan, and the systems to grow it. I didn\'t just build something—I became the kind of educator I wanted to be."',
  },
  {
    userCard: {
      imageSignedId: "",
      placeholder: userImagePlaceholder6,
      header: "Aisha Meher",
      description: "Content Creator",
    },
    content:
      '"I\'ve taken other programs, but this one helped me actually finish and ship my course. The Elevate system is smart, clear, and totally doable—even as a busy solo founder."',
  },
] as const;

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "EvergreenHomepageBlock8",
  props: {
    header: {
      prop: "children",
      type: "children",
      value: [
        createH2Block({
          text: "Real leaders. Real growth",
          styles: {
            textAlign: getTextAlignOptions("center"),
            maxWidth: getMaxWidthOptions({
              defaultValue: `${TABLET_WIDTH}px`,
            }),
          },
        }),
        createPBlock({
          text: "From career pivots to executive breakthroughs, our coaching and community have empowered leaders to achieve their biggest goals.",
          styles: {
            textAlign: getTextAlignOptions("center"),
            maxWidth: getMaxWidthOptions({
              defaultValue: `${TABLET_WIDTH}px`,
            }),
          },
        }),
      ],
    },
    content: {
      prop: "children",
      type: "children",
      value: cards.map(card =>
        createTestimonial2Block({
          content: card.content,
          userCard: {
            signedId: card.userCard.imageSignedId,
            placeholder: card.userCard.placeholder,
            header: card.userCard.header,
            description: card.userCard.description,
          },
        }),
      ),
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        backgroundColor: getBackgroundColorOptions({
          defaultValue: primaryBlockDefaultStyles.backgroundColor,
        }),
        padding: getPaddingOptions({
          defaultValue: primaryBlockDefaultStyles.padding,
        }),
        margin: getMarginOptions({
          defaultValue: primaryBlockDefaultStyles.margin,
        }),
      },
    },
  },
};
